/**
 * @hidden
 */
export var isObject = function (value) {
    return typeof value === 'object';
};
